import { AxiosResponse } from "axios";
import axiosInstance from "./base";
import { IHbDeal } from "../shared/types/HbDeal.type";
import { TChannel } from "../shared/types/Channel.type";


export type SendMsgDto = {
    text_fr: string
    text_en: string
    communication_channels: string[]
}

export class HbDeal {


    static getDealById(userId: number, dealId: number): Promise<AxiosResponse<IHbDeal>> {
        return axiosInstance.get(`/users/${userId}/onboarding_data?hubspot_deal_id=${dealId}`)
    }

    static createGroup(numbers: string[], groupName: string): Promise<AxiosResponse<{ group_uuid: string }>> {
        return axiosInstance.post(`/whatsapp_groups`, { numbers, name: groupName })
    }

    static saveWhatsappGroupChannel(data: Partial<TChannel>): Promise<AxiosResponse<TChannel>> {
        return axiosInstance.post('whatsapp_group_communication_channels', data)
    }

    static previewMessage(data: { text: string, user: string }): Promise<AxiosResponse<{ text: string }>> {
        return axiosInstance.post('whatsapp_messages/preview', data)
    }


    static sendWaMessage(data: SendMsgDto): Promise<AxiosResponse<any>> {
        return axiosInstance.post('whatsapp_messages/send', data)
    }

}